//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { CETELEM_POPUP_URL } from '~/const/3rd';

const EcoPartModal = () => import(
/* webpackMode: "eager"  */
'~/components/molecules/Product/Modal/EcoPartModal.vue');

const Sequra = () => import(
/* webpackMode: "eager" */
'~/components/atoms/Product/Sequra.vue');

export default {
  name: 'ThePriceSection',
  components: {
    Sequra
  },
  props: {
    price: {
      type: Object,
      required: true
    },
    loans: {
      type: Array,
      default: () => []
    },
    priceType: {
      type: String,
      default: ''
    },
    lot: {
      type: Number,
      required: true
    },
    hasSequra: {
      type: Boolean,
      default: false
    },
    offer: {
      type: Object,
      default: () => null
    },
    isMarketplace: {
      type: Boolean,
      required: false
    }
  },

  data() {
    return {
      show20x: false,
      showModal: false,
      EcoPartModal: null
    };
  },

  computed: {
    hasSet() {
      return this.lot > 1;
    },

    cetelemPopupUrl() {
      return CETELEM_POPUP_URL;
    },

    cb() {
      if (!this.loans) return null;
      const filtredLoans = this.loans.filter(loan => loan.provider === 'CB');
      return filtredLoans ? filtredLoans[0] : null;
    },

    cetelem() {
      return this.loans ? this.loans.filter(loan => loan.provider === 'CETELEM') : null;
    },

    hasDiscount() {
      return this.price.sales.amount > 0;
    },

    ecoPart() {
      return this.$t('eco_part', {
        x: this.price.eco.formatted
      });
    },

    actualFormattedPrice() {
      return this.price.sales.amount ? this.price.sales.formatted : this.price.base.formatted;
    },

    actualPrice() {
      return this.price.sales.amount ? this.price.sales.amount : this.price.base.amount;
    }

  },
  methods: {
    openPopup(url) {
      window.open(url, 'Cetelem', 'height=700,width=800');
    },

    closeAction() {
      this.showModal = false;
    },

    showEcoPartModal() {
      this.EcoPartModal = EcoPartModal;
      this.showModal = true;
    },

    trackCredit(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_paiement_sans_frais',
          event_label: "".concat(window.tc_vars.page_cat1, "/").concat(window.tc_vars.page_cat2, "/").concat(window.tc_vars.page_cat3, "/").concat(window.tc_vars.page_cat4, "/").concat(window.tc_vars.page_cat5)
        }
      });
    }

  }
};